module.exports = __webpack_public_path__ + "media/images/top/icon/blue-pale/ico_location-77ce775c147d8f9af86a0a311c78860e.svg";